import React, { FunctionComponent } from 'react';
import withStyles from 'react-jss';
import { FieldError, DeepMap, MultipleFieldErrors } from 'react-hook-form';
import { ErrorMessage } from '@hookform/error-message';

import { ClassProp } from 'helpers/types';
import { Theme } from 'config';

type Styles = ClassProp<ReturnType<typeof styles>>;

type Props = {
  classes: Styles;
  name: string;
  errors: DeepMap<Record<string, any>, FieldError>;
};

const styles = (theme: Theme) => ({
  fieldError: {
    fontSize: '.85714286rem',
    color: theme.error.color,
    fontWeight: 700,
    marginTop: '.25rem',
    margin: '0 .14285714em !important',
    padding: '.5833em .833em',
    '&:before': {
      content: '"⚠ "',
    },
  },
});

const renderError = (
  message: string,
  messages: MultipleFieldErrors | undefined,
  classes: Styles,
) => {
  if (messages) {
    return Object.entries(messages).map(([type, message]) => (
      <p key={type} className={classes.fieldError}>
        {message}
      </p>
    ));
  }
  return <p className={classes.fieldError}>{message}</p>;
};

const FormError: FunctionComponent<Props> = ({ classes, name, errors }) => (
  <ErrorMessage
    errors={errors}
    name={name}
    render={({ message, messages }) => renderError(message, messages, classes)}
  ></ErrorMessage>
);

export default withStyles(styles)(FormError);
